import styled from 'styled-components';

export default styled.article`
  display: flex;
  flex-direction: row;
  position: relative;

  .thumbnail {
    width: 5rem;
    height: 5rem;
    position: relative;
    margin-right: 1rem;
    flex-shrink: 0;

    picture {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 3px;
      overflow: hidden;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .data {
    a {
      text-decoration: none;

      &::after {
        display: block;
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        cursor: pointer;
      }
    }
  }
`;
